import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Row, Col, ListGroup, Image, Card } from "react-bootstrap";
import Message from "../components/Message";
import { useSelector, useDispatch } from "react-redux";
import CheckoutSteps from "../components/CheckoutSteps";
import { createOrder } from "../redux/actions/orderActions";
import { ORDER_CREATE_RESET } from "../redux/constants/orderConstants";
import { listCategoryDiscounts } from "../redux/actions/categoryDiscountActions";
import { validateCoupon, clearCoupon } from "../redux/actions/couponActions";
import {
  clearDirectPurchase,
  savePaymentMethod,
} from "../redux/actions/cartActions";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Loading from "../components/Loading";
import qrcode from "../assets/g-pay-qr.jpeg";

const FloatingOrderSummary = ({
  originalSubtotal,
  subtotalWithCategoryDiscount,
  categoryDiscountTotal,
  couponApplied,
  coupon,
  couponDiscount,
  cartSummary,
  itemsPrice,
  placeOrderHandler,
  couponCode,
  setCouponCode,
  couponAppliedState,
  handleApplyCoupon,
  handleRemoveCoupon,
  couponLoading,
  couponError,
  transactionId,
  setTransactionId,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const totalQuantity = (cartSummary.cartItems || []).reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0,
  );
  const directPurchase = useSelector((state) => state.directPurchase);
  const isDirectPurchase = directPurchase && directPurchase.product !== null;

  return (
    <div
      className="floating-order-summary"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#fff",
        borderTop: "1px solid #ddd",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
        zIndex: 1100,
        maxHeight: isExpanded ? "90dvh" : "60px",
        overflowY: isExpanded ? "auto" : "hidden",
        transition: "max-height 0.3s ease",
        padding: "8px 16px",
        fontSize: "0.9rem",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label={
          isExpanded ? "Collapse order summary" : "Expand order summary"
        }
      >
        <div>
          <strong>Total:</strong> Rs.{" "}
          {Math.round(Number(cartSummary.totalPrice || 0))} ・ {totalQuantity}{" "}
          items
        </div>
        <div>
          {isExpanded ? (
            <FaChevronDown />
          ) : (
            <Button
              variant="primary"
              size="sm"
              onClick={() => setIsExpanded(true)}
            >
              Buy Now
            </Button>
          )}
        </div>
      </div>

      <div
        style={{
          marginTop: 12,
          maxHeight: isExpanded ? "calc(90dvh - 60px)" : 0,
          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
        aria-hidden={!isExpanded}
      >
        <div style={{ marginTop: 12 }}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <Row>
                <Col>Items</Col>
                <Col>
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "#999",
                      marginRight: 8,
                    }}
                  >
                    Rs. {Math.round(Number(originalSubtotal || 0))}
                  </span>
                  <span style={{ color: "#3a6d3eff", fontWeight: 400 }}>
                    Rs. {Math.round(Number(subtotalWithCategoryDiscount || 0))}
                  </span>
                </Col>
              </Row>
              {Math.round(Number(categoryDiscountTotal || 0)) > 0 && (
                <Row>
                  <Col>
                    <span style={{ color: "#3a6d3eff" }}>
                      You can save Rs.{" "}
                      {Math.round(Number(categoryDiscountTotal))} on this order!
                    </span>
                  </Col>
                </Row>
              )}
            </ListGroup.Item>

            {couponApplied && coupon && !couponError && (
              <ListGroup.Item>
                <Row>
                  <Col>Coupon</Col>
                  <Col>
                    -{coupon.discountPercent}% (−₹
                    {Math.round(Number(couponDiscount || 0))})
                  </Col>
                </Row>
              </ListGroup.Item>
            )}

            <ListGroup.Item>
              <Row>
                <Col>Shipping</Col>
                <Col>
                  Rs. {Math.round(Number(cartSummary.shippingPrice || 0))}
                </Col>
              </Row>
              {cartSummary.paymentMethod === "UPI" &&
                Number(itemsPrice) < 2000 && (
                  <Row>
                    <Col
                      style={{
                        color: "green",
                        marginTop: "0.25rem",
                        fontWeight: "bold",
                      }}
                    >
                      Add items worth Rs.{" "}
                      {2000 - Math.round(Number(itemsPrice || 0))} for free
                      delivery!
                    </Col>
                  </Row>
                )}
            </ListGroup.Item>

            <ListGroup.Item>
              <Row>
                <Col>Total</Col>
                <Col>Rs. {Math.round(Number(cartSummary.totalPrice || 0))}</Col>
              </Row>
            </ListGroup.Item>

            {/* Payment & place order */}
            {cartSummary.paymentMethod === "UPI" ? (
              <>
                <ListGroup.Item className="text-center">
                  <img
                    src={qrcode}
                    alt="UPI QR Code"
                    style={{ maxWidth: "120px" }}
                  />
                  <div className="mt-2">
                    <strong>Pay using UPI ID:</strong>
                    <div>rushipatel5112@oksbi</div>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label htmlFor="transactionId">Enter Transaction ID</label>
                  <input
                    id="transactionId"
                    type="text"
                    className="form-control"
                    placeholder="Enter UPI Transaction ID"
                    value={transactionId}
                    onChange={(e) => setTransactionId(e.target.value)}
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <Button
                    className="w-100"
                    variant="primary"
                    disabled={
                      ((cartSummary.cartItems || []).length === 0 &&
                        !isDirectPurchase) ||
                      transactionId.trim() === ""
                    }
                    onClick={placeOrderHandler}
                  >
                    Confirm & Place Order
                  </Button>
                </ListGroup.Item>
              </>
            ) : (
              <ListGroup.Item>
                <Button
                  className="w-100"
                  variant="primary"
                  disabled={
                    (cartSummary.cartItems || []).length === 0 &&
                    !isDirectPurchase
                  }
                  onClick={placeOrderHandler}
                >
                  PLACE ORDER
                </Button>
              </ListGroup.Item>
            )}
          </ListGroup>
        </div>
      </div>
    </div>
  );
};

const PlaceOrderScreen = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [couponCode, setCouponCode] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  const directPurchase = useSelector((state) => state.directPurchase);
  const isDirectPurchase = directPurchase && directPurchase.product !== null;

  // final line total for an item after category discount + coupon
  const getLineFinalTotal = (item) => {
    const unitAfterCategory = getDiscountedPrice(item); // already defined above

    // if no coupon, just category-discounted total
    if (!coupon || !coupon.discountPercent || !couponApplied || couponError) {
      return Number(unitAfterCategory) * Number(item.qty);
    }

    // proportional share of coupon based on this line's share of subtotal
    const lineSubtotalAfterCategory =
      Number(unitAfterCategory) * Number(item.qty);

    if (subtotalWithCategoryDiscount <= 0) {
      return lineSubtotalAfterCategory;
    }

    const lineShare =
      lineSubtotalAfterCategory / Number(subtotalWithCategoryDiscount);

    const lineCouponAmount = lineShare * Number(couponDiscount || 0);

    const lineFinalTotal = lineSubtotalAfterCategory - lineCouponAmount;

    return Math.round(lineFinalTotal);
  };

  useEffect(() => {
    dispatch({ type: ORDER_CREATE_RESET });
    dispatch(clearCoupon());
    dispatch(listCategoryDiscounts());

    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  const cart = useSelector((state) => state.cart);
  const { discounts = [] } = useSelector((state) => state.categoryDiscountList);
  const { order, success, error, loading } = useSelector(
    (state) => state.orderCreate,
  );
  const couponValidate = useSelector((state) => state.couponValidate);
  const { loading: couponLoading, error: couponError, coupon } = couponValidate;
  const couponApplied = !!coupon && !couponError; // ADD THIS LINE

  // Category discounts & pricing logic (same as before)
  const getCategoryDiscount = (category) => {
    const d = discounts.find((x) => x.category === category);
    return d ? d.percent : 0;
  };

  const getDiscountedPrice = (item) => {
    const percent = getCategoryDiscount(item.category);
    if (percent) {
      // return number (not string) to avoid later concatenation bugs
      return item.price * (1 - percent / 100);
    } else {
      return Number(item.price);
    }
  };

  // --- Build the array of items we'll actually use for this order ---
  const cartItemsToUse = isDirectPurchase
    ? [
        {
          product: directPurchase.product._id || directPurchase.product.product,
          name: directPurchase.product.name,
          image: directPurchase.product.image,
          price: Number(directPurchase.product.price),
          category: directPurchase.product.category,
          size: directPurchase.size,
          qty: Number(directPurchase.qty),
          countInStock:
            directPurchase.product.countInStock ||
            directPurchase.product.quantity ||
            0,
        },
      ]
    : (cart.cartItems || []).map((item) => ({
        product: item.product,
        name: item.name,
        image: item.image,
        price: Number(item.price),
        category: item.category,
        size: item.size,
        qty: Number(item.qty),
        countInStock: item.countInStock,
      }));

  // --- Subtotals based on items we actually use ---
  const originalSubtotal = cartItemsToUse.reduce(
    (acc, item) => acc + Number(item.price) * Number(item.qty),
    0,
  );

  const subtotalWithCategoryDiscount = cartItemsToUse.reduce(
    (acc, item) => acc + Number(getDiscountedPrice(item)) * Number(item.qty),
    0,
  );

  const categoryDiscountTotal = originalSubtotal - subtotalWithCategoryDiscount;

  // --- Coupon ---
  let couponDiscount = 0;
  let itemsPrice = subtotalWithCategoryDiscount;
  if (coupon && coupon.discountPercent && couponApplied && !couponError) {
    couponDiscount = (coupon.discountPercent / 100) * itemsPrice;
    itemsPrice = itemsPrice - couponDiscount;
  }

  // --- Shipping logic (don't mutate original cart) ---
  let shippingPrice = 0;
  if (cart.paymentMethod === "COD") {
    shippingPrice = 100;
  } else if (cart.paymentMethod === "UPI") {
    shippingPrice = Number(itemsPrice) < 1999 ? 100 : 0;
  } else {
    shippingPrice = 0;
  }

  // --- Final totals ---
  const itemsPriceFixed = Number(Number(itemsPrice).toFixed(2));
  const shippingPriceFixed = Number(Number(shippingPrice).toFixed(2));
  const totalPrice = Number((itemsPriceFixed + shippingPriceFixed).toFixed(2));

  // Build a cartSummary object for UI components to consume (without mutating redux cart)
  const cartSummary = {
    ...cart,
    cartItems: cartItemsToUse,
    itemsPrice: itemsPriceFixed,
    shippingPrice: shippingPriceFixed,
    totalPrice: totalPrice,
  };

  useEffect(() => {
    if (location.state?.from === "cart") {
      dispatch(clearDirectPurchase());
    }
  }, [dispatch, location.state]);

  useEffect(() => {
    if (success && order?._id) {
      // Navigate to order details page and replace the history entry
      navigate(`/order/${order._id}`, { replace: true });
      dispatch({ type: ORDER_CREATE_RESET });
      dispatch(clearCoupon());
    }
  }, [dispatch, success, order?._id, navigate]);

  useEffect(() => {
    if (cart.paymentMethod === "COD") {
      dispatch({ type: "CART_SAVE_PAYMENT_METHOD" });
      dispatch(savePaymentMethod("UPI"));
    }
  }, []);

  const handleApplyCoupon = () => {
    if (couponCode.trim()) {
      dispatch(validateCoupon(couponCode.trim()));
    }
  };

  const handleRemoveCoupon = () => {
    dispatch(clearCoupon());
    setCouponCode("");
  };

  const placeOrderHandler = () => {
    //changes for only COD

    if (cart.paymentMethod === "COD") {
      // Show error or redirect back
      dispatch({ type: "ORDER_CREATE_FAIL", payload: "COD not available" });
      return;
    }

    const isPaid = cartSummary.paymentMethod === "UPI";
    const paidAt = isPaid ? new Date().toISOString() : null;

    // Build orderItems payload from cartItemsToUse (single source of truth)
    const orderItemsPayload = cartItemsToUse.map((item) => {
      const discounted = getDiscountedPrice(item); // already there
      const lineFinal = getLineFinalTotal(item); // ✅ USE YOUR HELPER

      return {
        product: item.product,
        name: item.name,
        image: item.image,
        originalPrice: Number(item.price),
        discountedPrice: Number(discounted),
        price: Number(discounted),
        category: item.category,
        size: item.size,
        qty: item.qty,
        countInStock: item.countInStock || 0,
        finalLineTotal: Number(lineFinal), // ✅ NEW FIELD
      };
    });

    dispatch(
      createOrder({
        orderItems: orderItemsPayload,
        shippingAddress: cart.shippingAddress,
        paymentMethod: cartSummary.paymentMethod,
        shippingPrice: cartSummary.shippingPrice,
        itemsPrice: cartSummary.itemsPrice, // ✅ ADD
        couponDiscount: couponDiscount || 0, // ✅ ADD
        totalPrice: cartSummary.totalPrice,
        couponCode: couponApplied ? coupon.code : undefined,
        isPaid,
        paidAt,
        transactionId: isPaid ? transactionId : null,
      }),
    );

    // If this was a direct purchase, clear it after creating order (so future visits are normal)
    if (isDirectPurchase) {
      dispatch(clearDirectPurchase());
    }
  };

  return (
    <>
      <CheckoutSteps step2 step4 />
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            {error && (
              <ListGroup.Item>
                <Message variant="danger">{error}</Message>
              </ListGroup.Item>
            )}

            <ListGroup.Item>
              <h4 style={{ fontWeight: "500", marginBottom: "12px" }}>
                Shipping
              </h4>
              <strong>Address:</strong>
              <p>
                {cart.shippingAddress.address}, {cart.shippingAddress.city}{" "}
                {cart.shippingAddress.postalCode},{" "}
                {cart.shippingAddress.country}
              </p>
              <strong>Receiver's Contact Number:</strong>
              <p>{cart.shippingAddress.receiverContactNumber || "N/A"}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h4 style={{ fontWeight: "500", marginBottom: "12px" }}>
                Payment Method
              </h4>
              <strong>Method : </strong>
              {cartSummary.paymentMethod}
            </ListGroup.Item>

            <ListGroup.Item>
              <h4>Order Items</h4>
              {loading ? (
                <Loading /> // show spinner while placing order
              ) : cartSummary.cartItems.length === 0 ? (
                <Message variant="info">Your cart is empty</Message>
              ) : (
                <>
                  {cartSummary.cartItems.map((item, index) => (
                    <ListGroup.Item
                      key={index}
                      onClick={() =>
                        navigate(`/product/${item.product}`, {
                          state: { from: "/placeorder" },
                        })
                      }
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        marginBottom: "10px",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                        gap: "12px",
                        cursor: "pointer",
                      }}
                    >
                      <Image
                        src={item.image}
                        alt={item.name}
                        style={{
                          width: "72px",
                          height: "108px",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                      />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: "600", fontSize: "1rem" }}>
                          {item.name}
                        </div>
                        <div
                          style={{
                            fontSize: "0.85rem",
                            color: "#555",
                            marginTop: "4px",
                          }}
                        >
                          Size: {item.size || "N/A"}
                        </div>
                        <div style={{ marginTop: "6px", fontWeight: "bold" }}>
                          ₹{Math.round(item.price)}
                        </div>
                        <div>Qty: {item.qty}</div>
                      </div>
                    </ListGroup.Item>
                  ))}
                </>
              )}
            </ListGroup.Item>

            <ListGroup.Item>
              <label htmlFor="couponCode">Coupon Code</label>
              <input
                id="couponCode"
                type="text"
                className="form-control"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                disabled={couponApplied}
                placeholder="Enter coupon code"
                style={{ marginBottom: "8px" }}
              />
              {!couponApplied ? (
                <Button
                  onClick={handleApplyCoupon}
                  disabled={couponApplied || !couponCode}
                  className="mb-2"
                  variant="secondary"
                >
                  Apply
                </Button>
              ) : (
                <Button
                  onClick={handleRemoveCoupon}
                  className="mb-2"
                  style={{
                    backgroundColor: "#B45309",
                    borderColor: "#B45309",
                    color: "#FFFFFF",
                  }}
                >
                  Remove
                </Button>
              )}
              {couponLoading && <Message variant="info">Validating...</Message>}
              {couponError && <Message variant="danger">{couponError}</Message>}
              {couponApplied && coupon && !couponError && (
                <Message variant="success">
                  Coupon applied: {coupon.code} ({coupon.discountPercent}% OFF)
                </Message>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>

        {/* Desktop order summary */}
        {!isMobile && (
          <Col md={4}>
            <Card className="no-hover-card">
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <h4>Order Summary</h4>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>Items</Col>
                    <Col className="text-end">
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "#999",
                          marginRight: 8,
                        }}
                      >
                        Rs. {Math.round(originalSubtotal)}
                      </span>
                      <span style={{ fontWeight: 400 }}>
                        Rs. {Math.round(subtotalWithCategoryDiscount)}
                      </span>
                    </Col>
                  </Row>
                  {Math.round(categoryDiscountTotal) > 0 && (
                    <Row>
                      <Col className="text-end">
                        <span style={{ color: "#3a6d3eff" }}>
                          You can save Rs. {Math.round(categoryDiscountTotal)}{" "}
                          on this order!
                        </span>
                      </Col>
                    </Row>
                  )}
                </ListGroup.Item>
                {couponApplied && coupon && !couponError && (
                  <ListGroup.Item>
                    <Row>
                      <Col>Coupon</Col>
                      <Col className="text-end">
                        -{coupon.discountPercent}% (−₹
                        {Math.round(couponDiscount)})
                      </Col>
                    </Row>
                  </ListGroup.Item>
                )}
                <ListGroup.Item>
                  <Row>
                    <Col>Shipping</Col>
                    <Col className="text-end">
                      Rs. {cartSummary.shippingPrice}
                    </Col>
                  </Row>
                  {cartSummary.paymentMethod === "UPI" && itemsPrice < 2000 && (
                    <Row>
                      <Col
                        style={{
                          color: "green",
                          marginTop: "0.25rem",
                          fontWeight: "bold",
                        }}
                      >
                        Add items worth Rs. {2000 - Math.round(itemsPrice)} for
                        free delivery!
                      </Col>
                    </Row>
                  )}
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>Total</Col>
                    <Col className="text-end">
                      Rs. {Math.round(cartSummary.totalPrice)}
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div style={{ fontWeight: "500", marginBottom: "6px" }}>
                    Items in this order
                  </div>
                  {cartSummary.cartItems.map((item, idx) => {
                    const lineFinal = getLineFinalTotal(item); // final amount for this product
                    return (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "0.9rem",
                          marginBottom: 4,
                        }}
                      >
                        <span>
                          {item.name} × {item.qty}
                        </span>
                        <span>Rs. {Math.round(lineFinal)}</span>
                      </div>
                    );
                  })}
                </ListGroup.Item>

                {cartSummary.paymentMethod === "UPI" ? (
                  <>
                    <ListGroup.Item className="text-center">
                      <div>
                        <img
                          src={qrcode}
                          alt="UPI QR Code"
                          style={{ maxWidth: "200px" }}
                        />
                      </div>
                      <div className="mt-2">
                        <strong>Pay using UPI ID:</strong>
                        <div>rushipatel5112@oksbi</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <label htmlFor="transactionId">
                        Enter Transaction ID
                      </label>
                      <input
                        id="transactionId"
                        type="text"
                        className="form-control"
                        placeholder="Enter UPI Transaction ID"
                        value={transactionId}
                        onChange={(e) => setTransactionId(e.target.value)}
                      />
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Button
                        className="w-100"
                        variant="primary"
                        disabled={
                          (cartSummary.cartItems || []).length === 0 ||
                          transactionId.trim() === ""
                        }
                        onClick={placeOrderHandler}
                      >
                        Confirm & Place Order
                      </Button>
                    </ListGroup.Item>
                  </>
                ) : (
                  <ListGroup.Item>
                    <Button
                      className="w-100"
                      variant="primary"
                      disabled={(cartSummary.cartItems || []).length === 0}
                      onClick={placeOrderHandler}
                    >
                      PLACE ORDER
                    </Button>
                  </ListGroup.Item>
                )}
              </ListGroup>
            </Card>
          </Col>
        )}
      </Row>

      {/* Floating order summary on mobile */}
      {isMobile && (
        <FloatingOrderSummary
          originalSubtotal={originalSubtotal}
          subtotalWithCategoryDiscount={subtotalWithCategoryDiscount}
          categoryDiscountTotal={categoryDiscountTotal}
          couponApplied={couponApplied}
          coupon={coupon}
          couponDiscount={couponDiscount}
          cartSummary={cartSummary}
          itemsPrice={itemsPrice}
          placeOrderHandler={placeOrderHandler}
          couponCode={couponCode}
          setCouponCode={setCouponCode}
          couponAppliedState={couponApplied}
          handleApplyCoupon={handleApplyCoupon}
          handleRemoveCoupon={handleRemoveCoupon}
          couponLoading={couponLoading}
          couponError={couponError}
          transactionId={transactionId}
          setTransactionId={setTransactionId}
        />
      )}

      {/* Padding so content is not hidden behind fixed bar */}
      {isMobile && <div style={{ height: 60 }}></div>}
    </>
  );
};

export default PlaceOrderScreen;
